import { useEffect, useState } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

const HIGHLIGHT_MS = 4000;

export function resourceAnchorId(id: string): string {
  return `resource-${id}`;
}

/**
 * Deep link into a resource list: `?highlight=<resource id>` (Niva's citation
 * links) scrolls that entry into view once the list has loaded and marks it as
 * highlighted for a few seconds. Keyed on location.key so clicking the same
 * citation again replays it.
 */
export function useResourceHighlight(loaded: boolean) {
  const [params] = useSearchParams();
  const { key } = useLocation();
  const targetId = params.get("highlight");
  const [highlightedId, setHighlightedId] = useState<string | null>(null);

  useEffect(() => {
    if (!loaded || !targetId) return;
    setHighlightedId(targetId);
    // After the render that applies the highlight (and opens an FAQ answer).
    const scroll = window.setTimeout(() => {
      document.getElementById(resourceAnchorId(targetId))?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 50);
    const clear = window.setTimeout(() => setHighlightedId(null), HIGHLIGHT_MS);
    return () => {
      window.clearTimeout(scroll);
      window.clearTimeout(clear);
    };
  }, [loaded, targetId, key]);

  return { targetId, highlightedId };
}
